/**
 * Replaces default Casper's infinite loading with a "load more" button.
 */

(function (window, document) {
    // next link element
    var nextElement = document.querySelector('link[rel=next]');
    if (!nextElement) {
        return;
    }

    // post feed element
    var feedElement = document.querySelector('.post-feed');
    if (!feedElement) {
        return;
    }

    var loaderElement = document.getElementById('read-more-trigger');
    if (!loaderElement) {
      return;
    }

    var loading = false;

    function onPageLoad() {
        if (this.status === 404) {
            loaderElement.style.display = 'none';
            return;
        }

        // append contents
        var postElements = this.response.querySelectorAll('article.post-card');
        postElements.forEach(function (item) {
            // document.importNode is important, without it the item's owner
            // document will be different which can break resizing of
            // `object-fit: cover` images in Safari
            feedElement.appendChild(document.importNode(item, true));
        });

        // set next link
        var resNextElement = this.response.querySelector('link[rel=next]');
        if (resNextElement) {
            nextElement.href = resNextElement.href;
        } else {
            loaderElement.style.display = 'none';
        }

        // sync status
        lastDocumentHeight = document.documentElement.scrollHeight;
        loading = false;
    }

    function onLoaderClick() {
      // return if already loading
      if (loading) {
        return;
      }

      loading = true;

      var xhr = new window.XMLHttpRequest();
      xhr.responseType = 'document';

      xhr.addEventListener('load', onPageLoad);

      xhr.open('GET', nextElement.href);
      xhr.send(null);
    }

    loaderElement.addEventListener('click', onLoaderClick);
    onPageLoad();
})(window, document);
